import React, { useState, useEffect } from "react";
import Info from "./Info";
import Notify from "./Notify";
import Preferences from "./Preferences";
import { updateUser } from "../../../../../redux/profile/api";
import { toast } from "react-toastify";
import { baseURL } from "../../../../../utils/config";

export default function Basic({
  data,
  fetchProfileData,
  isSignIn,
  isConnected,
  getAuth,
}) {
  const [form, setForm] = useState({
    avatar: "",
    name: "",
    description: "",
    facebookLink: "",
    telegramLink: "",
    linkedinLink: "",
    error: { facebook: null, telegram: null, linkedin: null },
    // notifications
    updates: true,
    newsletter: false,
    purchases: true,
    // preferences
    language: "English",
    theme: "Dark",
    currency: "US Dollar ($)",
  });
  function isUrlValid(url) {
    const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?'+ // port
    '(\\/[-a-z\\d%@_.~+&]*)*'+ // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(url);
  }


  const onSave = async () => {
    try {
      const payload = {
        socialLinks: {},
        $auth: getAuth,
      };
      if (form?.name) {
        payload.name = form.name;
      }
      if (form?.description) {
        payload.description = form.description;
      }
      payload.socialLinks.Facebook = form?.facebookLink;
      payload.socialLinks.Telegram = form?.telegramLink;
      payload.socialLinks.LinkedIn = form?.linkedinLink;
debugger
        if (form?.facebookLink && !isUrlValid(form?.facebookLink)) {
          return setForm({ ...form, error: { ...form.error, facebook: true } });
        }
        else{
          setForm({ ...form, error: { ...form.error, facebook: null } });

        }
        if (form?.telegramLink&& !isUrlValid(form?.telegramLink)) {
          return setForm({ ...form, error: { ...form.error, telegram: true } });
        }else{
          setForm({ ...form, error: { ...form.error, facebook: null } });

        }
        if (form?.linkedinLink&& !isUrlValid(form?.linkedinLink)) {
          return setForm({ ...form, error: { ...form.error, linkedin: true } });
        }else{
          setForm({ ...form, error: { ...form.error, facebook: null } });

        }

      await toast.promise(updateUser(payload), {
        pending: "Updating user profile...",
        success: "User profile upated successfully!",
        error: "Failed to update user profle!",
      });

      // const res = await updateUser(payload);
      fetchProfileData();
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (data && Object.keys(data).length) {
      const newObj = {
        name: data?.name || "",
        avatar: data?.image
          ? `${baseURL}/images/${data?.image}`
          : "",
        description: data?.description || "",
        facebookLink: data?.socialLinks?.Facebook || "",
        telegramLink: data?.socialLinks?.Telegram || "",
        linkedinLink: data?.socialLinks?.LinkedIn || "",
      };
      setForm({ ...form, ...newObj });
    }
  }, [data]);

  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  return (
    <>
      <Info
        fetchProfileData={fetchProfileData}
        onChangeInput={onChangeInput}
        form={form}
        updateForm={updateForm}
        isSignIn={isSignIn}
        isConnected={isConnected}
      />
      {/* <Notify
        onChangeInput={onChangeInput}
        form={form}
        updateForm={updateForm}
      />
      <Preferences
        onChangeInput={onChangeInput}
        form={form}
        updateForm={updateForm}
      /> */}
      <div className="wallets__inner-footer">
        <button
          disabled={!isSignIn || !isConnected}
          type="button"
          className="button primary"
          onClick={onSave}
        >
          Save
        </button>
      </div>
      {/* <Info /> */}
    </>
  );
}
